import React from "react";
import { connect } from "react-redux";

const mapState = (state) => {
	return {
		listaFamiliares: state.af.listaFamiliares,
		listaPolizas: state.af.listaPolizas,
		sinPolizas: state.af.sinPolizas,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		editarFamiliar: (oFamiliar) => {
			dispatch({ "type": "AF_EDITAR_FAMILIAR", "familiar": oFamiliar});
			dispatch({ "type": "AF_EDITAR_PASO", "paso": 0});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class Invitados extends React.Component {

	seleccionaFamiliar = (_item) => {
		let oFamiliar = Object.assign({}, _item);
		this.props.editarFamiliar(oFamiliar);
		$("#modal-gestionar").modal({backdrop: "static", keyboard: false});
		
		// GOOGLE TAG MANAGER //
		this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_EDITAR_FAMILIAR", "dispositivo": this.props.dispositivo });
	}

	sinPolizas = () => {
		$("#modal-sin-polizas").hide();
		$("#modal-sin-polizas").modal("hide");
	}

	render() {
		return (
			<div className="cards-wrap mt-50">
				<div className="row">
					<div className="col-xs-12">
						<div className="row">
							{ this.props.listaFamiliares.length == 0 &&
								<div className="sin-invitaciones">
									<img src={ require("../img/icon-invitacion.png") } />
									<h6 className="blue-text mt-50">Aún no has invitado a nadie</h6>
									<p>Las personas que designes como invitados podrán visualizar tus pólizas de autos y reportar siniestros a través de la aplicación Soy Cliente GNP.</p>
									{ this.props.listaPolizas.length > 0 &&
										<button data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#modal-invitar">Invitar</button>
									}
								</div>
							}

							{ this.props.listaFamiliares.map((item, i) =>
								<div key={i} className="col-xs-12 col-md-4">
									<div onClick={this.seleccionaFamiliar.bind(this, item)}  className="card select-card">
										<img src={ require("../img/circle_contratante.png") } />
										<div className="invitado-info">
											<p className="blue-text">{item.nombre.length > 24 ? item.nombre.substring(0, 24) + "..." : item.nombre}</p>
											{ item.pendiente == true &&
												<p><span className="green-circle"></span><small className="gray-text">Invitación aceptada</small></p>
											}
											{ item.pendiente == false && item.polizas.length != 0 &&
												<p><span className="red-circle-no"></span><small className="gray-text">Pendiente de aceptar</small></p>
											}
											{ item.pendiente == false && item.polizas.length == 0 &&
												<p><span className="red-circle-no"></span><small className="gray-text">Sin pólizas compartidas</small></p>
											}
										</div>
										<div className="invitado-polizas pull-right">
											<span className="texto-20 orange-text">{ item.polizas.length }</span>
											<p><small className="gray-text"><b>Pólizas</b></small></p>
											<ul className="invitacion-options">
												<li><img src={ require("../img/icon-delete.png") } />Eliminar acceso</li>
												<li><img src={ require("../img/icon-add-small.png") } />Agregar póliza</li>
												<li><img src={ require("../img/icon-mail-send.png") } />Reenviar correo de invitación</li>
											</ul>
										</div>
									</div>
								</div>
							)}

							{ this.props.listaFamiliares.length != 0 &&
								<div className="col-xs-12 col-md-4">
									<a data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#modal-invitar" href="#modal-invitar">
										<div className="card select-card">
											<img src={require("../img/icon-add.svg")} style={{"width": "47px"}} />
											<div className="invitado-info" style={{"maxWidth":"initial"}}>
												<p className="blue-text">Agregar nuevo invitado</p>
											</div>
										</div>
									</a>
								</div>
							}

							{ this.props.sinPolizas &&
								<div className='modal fade in' style={{"display":"block"}} id='modal-sin-polizas' tabIndex='-1' role='dialog' aria-labelledby='modal-sin-polizas'>
									<div className="modal-backdrop fade in" style={{"zIndex":"0"}}></div>
									<div className='modal-dialog' role="document">
										<div className='modal-content'>
											<div className='modal-header'>
												<h4 className='modal-title orange-text' id='modal-celularLabel'>No cuentas con pólizas para realizar invitaciones.</h4>
											</div>
											<div className='modal-footer'>
												<button type='button' onClick={this.sinPolizas.bind(this)} className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
											</div>
										</div>
									</div>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Invitados);



// WEBPACK FOOTER //
// ./src/acceso-familiar/invitados.cmpt.js